import { cva } from 'class-variance-authority';

const switchBaseStyles = [
  'peer',
  'form-checkbox',
  'enabled:cursor-pointer',
  'disabled:cursor-not-allowed',
  'appearance-none',
  'w-8',
  'rounded-full',

  'before:w-4',
  'before:h-4',
  'before:absolute',
  'relative',
  'before:top-1/2',
  'checked:bg-none',
  'before:-translate-y-1/2',
  'before:left-0',
  'before:block',
  'before:border-2',
  'before:rounded-full',
  'checked:before:left-4',
  'before:transition-all',

  'focus:ring-0',
  'focus:ring-transparent',
  'focus:ring-offset-0',
  'focus:outline-none',
  'focus-visible:ring-2',
  'focus-visible:outline-2',
  'focus-visible:outline-offset-4',
];

const switchStylesSAG = cva([
  ...switchBaseStyles,
  'border-none',

  'bg-[#7D8099]',
  'hover:bg-[#66667E]',
  'text-[#005159]',

  'checked:bg-[#005159]',
  'checked:hover:bg-[#196269]',

  'before:bg-white',
  'before:border-[#7D8099]',
  'before:hover:border-[#66667E]',
  'checked:before:border-[#005159]',
  'checked:before:hover:border-[#196269]',

  'disabled:bg-[#E5E5E9]',
  'disabled:before:border-[#E5E5E9]',
  'disabled:before:bg-[#CCCCD4]',
  'disabled:checked:hover:bg-[#E5E5E9]',

  'dark:bg-[#737389]',
  'dark:hover:bg-[#9999A9]',
  'dark:text-[#00FFB9]',

  'dark:checked:bg-[#00FFB9]',
  'dark:checked:hover:bg-[#00E5AA]',

  'dark:before:bg-[#000028]',
  'dark:before:border-[#737389]',
  'dark:before:hover:border-[#9999A9]',
  'dark:checked:before:border-[#00FFB9]',
  'dark:checked:before:hover:border-[#00E5AA]',

  'dark:disabled:bg-[#333353]',
  'dark:disabled:before:border-[#333353]',
  'dark:disabled:before:bg-[#737389]',
  'dark:disabled:checked:hover:bg-[#333353]',
]);

const switchStylesSHS = cva([
  ...switchBaseStyles,
  'box-content',
  'border',

  'bg-white',
  'text-[#ec6602]',

  'border-[#666666]',
  'checked:border-[#ec6602]',

  'checked:bg-[#ec6602]',
  'checked:hover:bg-[#ec6602]',

  'before:bg-[#666666]',
  'before:border-white',
  'before:hover:border-white',
  'checked:before:bg-white',
  'checked:before:border-[#ec6602]',
  'checked:before:hover:border-[#ec6602]',

  'disabled:bg-white',
  'disabled:before:border-white',
  'disabled:before:bg-[#CCCCD4]',
  'disabled:checked:hover:bg-white',

  'dark:bg-[#1a1a1a]',
  'dark:text-[#ec6602]',
  'dark:border-[#999]',

  'dark:before:bg-[#999]',
  'dark:before:border-[#1a1a1a]',
  'dark:before:hover:border-[#1a1a1a]',
  'dark:checked:before:bg-white',
  'dark:checked:before:border-[#ec6602]',
  'dark:checked:before:hover:border-[#ec6602]',

  'dark:checked:bg-[#ec6602]',
  'dark:checked:border-[#ec6602]',
  'dark:checked:hover:bg-[#ec6602]',

  'dark:disabled:bg-transparent',
  'dark:disabled:before:border-black',
]);

export { switchStylesSAG, switchStylesSHS };
